import type { NavigateOptions } from "react-router";
import _ from "underscore";
import { convertHashPath } from "@/components/shared/Link";
import { getCvPartner } from "./getCvPartner";

export const navigateTo = async (route: string, opts?: NavigateOptions) => {
  if (!_.isString(route)) {
    return;
  }
  const replacedRoute = convertHashPath(route);

  await getCvPartner().navigate(replacedRoute, opts);
};

export const redirectTo = (path: string) => {
  window.location.href = path;
};
